import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '@/components/modal/modal-component';
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '@/components/button/button-component';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.COLOR_BG_LIGHT};
  gap: 10px;
`;

const InfoText = styled.p`
  color: ${({ theme }) => theme.COLOR_TEXT_SECONDARY};
  font-size: 14px;
  margin-left: 25px;
`;

/**
 * OptionViewParentModal Component
 *
 * Modal for selecting which historical option should be the parent when multiple
 * options exist with parent_option: null. This handles the migration of historical
 * data to the new parent-variant structure.
 *
 * @param {object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Function} props.onConfirm - Function called when parent is selected
 * @param {boolean} props.loading - Whether the operation is loading
 * @returns {JSX.Element} The rendered parent selection modal
 */
const OptionViewParentModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
}) => (
  <Modal
    open={isOpen}
    showClose
    title="Migrate Option"
    close={() => onClose()}
    width="600px"
    bodyStyle={{
      display: 'flex',
      flexDirection: 'column',
      padding: '0px',
    }}
  >
    <InfoText>Please migrate this option to have a parent option.</InfoText>

    <ButtonContainer>
      <PrimaryOutlineButton
        buttonWidth="108px"
        type="button"
        loading={false}
        title="Cancel"
        onClick={() => onClose()}
        margin="0 0 0 0"
      />
      <PrimaryButton
        buttonWidth="108px"
        type="submit"
        loading={loading}
        title="Edit"
        onClick={() => onConfirm()}
      />
    </ButtonContainer>
  </Modal>
);

OptionViewParentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default OptionViewParentModal;
